<template>
  <div class="notification-dropdown">
    <button
      class="dropdown-toggle text-start text-black-emphasis d-flex align-items-center position-relative bg-transparent border-0 transition lh-1"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <img src="../../../assets/img/icons/notification.svg" alt="admin" />
      <span
        v-if="badgeCount"
        class="position-absolute rounded-circle text-center end-0 text-white fw-medium"
      >
        {{ badgeCount > 9 ? '9+' : badgeCount }}
      </span>
    </button>
    <div
      class="dropdown-menu rounded-1 bg-white border-0 start-auto end-0 p-0"
      data-popper-placement="bottom-end"
    >
      <ul class="list-style dropdown-body">
        <li v-if="!items.length" class="text-muted py-3 text-center">Sin notificaciones pendientes</li>
        <li v-for="item in items" :key="item.id" class="text-muted position-relative">
          <span
            class="unread position-absolute top-50 start-0 rounded-circle d-inline-block"
          ></span>
          <router-link
            to="/transfer-list"
            class="d-block text-decoration-none text-title"
          >
            <strong class="fw-semibold">{{ titulo(item) }}</strong>
            <span class="d-block text-paragraph">GR {{ item.serie }}-{{ item.numero }}</span>
            <span class="d-block text-paragraph">{{ item.motivo }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import api from '../../../services/api';
import { getUser } from '../../../services/authService';
export default {
  name: "NotificationDropdown",
  data:()=>({items:[],timer:null,user:getUser()}),
  computed:{
    esAdmin(){return ['ADMIN','SISTEMAS','RAUL'].includes(String(this.user?.usuario||'').trim().toUpperCase());},
    badgeCount(){return this.esAdmin ? this.items.filter(i=>i.estado==='pendiente').length : this.items.filter(i=>i.estado==='aprobada'&&new Date(i.expira_at)>new Date()).length;}
  },
  mounted(){this.cargar();this.timer=setInterval(this.cargar,60000);},
  beforeUnmount(){clearInterval(this.timer);},
  methods:{
    async cargar(){try{const r=await api.get('/transferencias/correcciones/solicitudes');const all=r.data?.data||[];this.items=this.esAdmin?all.slice(0,5):all.filter(i=>i.estado==='aprobada'||i.estado==='rechazada').slice(0,5);}catch(e){this.items=[];}},
    titulo(i){if(this.esAdmin)return `Solicitud de ${i.solicitante_usuario}`;return i.estado==='aprobada'?'Corrección autorizada por 24 horas':'Solicitud rechazada';}
  }
};
</script>

<style lang="scss" scoped>
.notification-dropdown {
  .dropdown-toggle {
    padding: 2px 7px 0 0;
    span {
      width: 20px;
      height: 20px;
      top: -8px;
      font-size: 12px;
      line-height: 18px;
      background: var(
        --Purple-Gradient,
        linear-gradient(132deg, #4f46e5 4.27%, #6366f1 100%)
      );
      line-height: 20px;
      background: #0eb77a;
    }
  }
  .dropdown-menu {
    width: 315px;
    font-size: 14px;
    box-shadow: 0px 4px 34px rgba(101, 96, 240, 0.1);
    margin-top: 19px !important;
    margin-right: -10px !important;
    .dropdown-body {
      padding: 15px 28px;
      li {
        position: relative;
        padding: 15px 0 15px 30px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        .unread,
        .read {
          width: 12px;
          height: 12px;
          transform: translateY(-50%);
          i,
          img {
            opacity: 0.7;
          }
        }
        .unread {
          background-color: #0eb77a;
        }
        .read {
          background-color: #4f46e5;
        }
        &:last-child {
          border-bottom: none;
        }
        a {
          line-height: 22px;
        }
      }
    }
  }
}
</style>
